var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-page block" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass: "shop-page--header",
          style: { backgroundImage: `url(${_vm.image})` },
        },
        [_c("h1", [_vm._v(_vm._s(_vm.title))])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shop-page--filters" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.category,
                expression: "category",
              },
            ],
            attrs: { name: "store_select", id: "store_select" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.category = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v("I’m Looking For..."),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "" } }, [_vm._v("All")]),
            _vm._v(" "),
            _vm._l(_vm.categories, function (cat) {
              return _c("option", { domProps: { value: cat.slug } }, [
                _vm._v(_vm._s(cat.name)),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search",
            },
          ],
          attrs: { type: "search", placeholder: "Store Name Search..." },
          domProps: { value: _vm.search },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.search = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shop-page--inner" },
        _vm._l(_vm.paged, function (store) {
          return _c("div", { staticClass: "shop-page--inner--card" }, [
            _c("h2", { staticClass: "title" }, [
              _c("a", { attrs: { href: store.link } }, [
                _vm._v(_vm._s(store.title)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "time" }, [
              _vm._v(_vm._s(store.opening_time)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "floor" }, [_vm._v(_vm._s(store.floor))]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.show_more_button
        ? _c(
            "button",
            {
              staticClass: "load-more button",
              on: {
                click: function ($event) {
                  _vm.page++
                },
              },
            },
            [_vm._v("Load More...")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/StEnochShops.vue